import { writable } from "svelte/store";
import { DiscountResult, fetchDiscounts } from "@retailer/services/discounts_service";

const DiscountsLookupStore = writable<DiscountResult[]>([]);

export const hydrateDiscountsForInventories = async (inventoryIds: number[]): Promise<void> => {
  const discounts = await fetchDiscounts(inventoryIds);
  DiscountsLookupStore.set(discounts);
};

export default DiscountsLookupStore;
